import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeviceSettingsComponent } from './device-settings.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DeviceDetailsModule } from './device-details/device-details.module';
import { DeviceInfoModule } from './device-info/device-info.module';
import { DeviceUsersComponent } from './device-users/device-users.component';
import { ChangeDeviceTypeModule } from './change-device-type/change-device-type.module';
import { ChangeDoorModeModule } from './change-door-mode/change-door-mode.module';
import { UpdateDeviceNameComponent } from './update-device-name/update-device-name.component';
import { MatInputModule } from '@angular/material/input';
import { UserTypeResponseModule } from 'src/app/libs/ui/pipes/user-type-response/user-type-response.module';
import { ProfilePictureModule } from 'src/app/shared-layout/Components/profile-picture/profile-picture.module';
import { WithTooltipModule } from 'src/app/shared-layout/Components/with-tooltip/with-tooltip.module';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@NgModule({
  declarations: [
    DeviceSettingsComponent,
    DeviceUsersComponent,
    UpdateDeviceNameComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DeviceDetailsModule,
    DeviceInfoModule,
    ChangeDeviceTypeModule,
    ChangeDoorModeModule,
    MatInputModule,
    UserTypeResponseModule,
    ProfilePictureModule,
    WithTooltipModule,
    TranslateModule
  ],
  exports: [DeviceSettingsComponent],
  providers: [
    LocalizationService,
    TranslateModule
  ],
})
export class DeviceSettingsModule {}
